const MAX_PAST_HISTORY_ENTRY_COUNT = 10;
export const makeHistory = (state) => ({
    past: [],
    present: state,
    future: [],
});
const undo = (state) => {
    const { past, present, future } = state;
    if (!present) {
        return state;
    }
    if (past.length === 0) {
        return state;
    }
    const previous = past[past.length - 1];
    const newPast = past.slice(0, past.length - 1);
    return {
        past: newPast,
        present: previous,
        future: [present, ...future],
    };
};
const redo = (state) => {
    const { past, present, future } = state;
    if (!present) {
        return state;
    }
    if (future.length === 0) {
        return state;
    }
    const next = future[0];
    const newFuture = future.slice(1);
    return {
        past: [...past, present],
        present: next,
        future: newFuture,
    };
};
const updateHistory = (options) => {
    const { action, state, reducer } = options;
    const { past, present } = state;
    const newPresent = reducer(present, action);
    if (!present) {
        return makeHistory(newPresent);
    }
    if (present === newPresent) {
        return state;
    }
    return {
        past: [...past, present].slice(-MAX_PAST_HISTORY_ENTRY_COUNT),
        present: newPresent,
        future: [],
    };
};
export const undoable = (options) => {
    const { actionTypes, reducer } = options;
    const emptyHistoryState = makeHistory();
    return (state = emptyHistoryState, action) => {
        switch (action.type) {
            case actionTypes.undo:
                return undo(state);
            case actionTypes.redo:
                return redo(state);
            case actionTypes.snapshot:
                return updateHistory({
                    state,
                    reducer,
                    action,
                });
            default:
                return state;
        }
    };
};
